/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link, Switch, Redirect } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import "../../../../_metronic/_assets/sass/pages/login/login-3.scss";
import { useIntl } from "react-intl";
import { SITE_NAME } from "../../../../_emywork/helpers/UIHelper";
import { Footer } from "../../../../_metronic/layout/components/footer/Footer";
import ResetPassword from "./ResetPasswod";

export function AuthPage() {
  const { formatMessage } = useIntl();
  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-3 wizard d-flex flex-column flex-lg-row flex-column-fluid"
          id="kt_login"
        >
          <div className="login-aside d-flex flex-column flex-row-auto">
            <div className="d-flex flex-column-auto flex-column">
              <Link to="/" className="login-logo text-center">
                <img
                  alt="Logo"
                  className="max-h-100px"
                  src={toAbsoluteUrl("/media/logos/logo-dark.png")}
                />
              </Link>
              <h1 className="font-weight-bolder text-center font-size-h4 text-dark-50 line-height-xl px-3">
                {formatMessage(
                  { id: "AUTH.WELCOME.TITLE" },
                  { name: SITE_NAME }
                )}
                <br />
                <br />
                <span
                  dangerouslySetInnerHTML={{
                    __html: formatMessage({ id: "AUTH.WELCOME.MESSAGE" }),
                  }}
                />
              </h1>
            </div>
            <div
              className="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-x-center"
              style={{
                backgroundImage: `url(${toAbsoluteUrl(
                  "/media/misc/login-visual.png"
                )})`,
                // backgroundColor: "#F2C98A",
                backgroundPositionY: "calc(100% + 2rem)",
              }}
            />
          </div>

          {/*begin::Content*/}
          <div className="login-content flex-row-fluid d-flex flex-column px-10">
            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              <Switch>
                <ContentRoute path="/auth/login" component={Login} />
                <ContentRoute
                  path="/auth/registration"
                  component={Registration}
                />
                <ContentRoute
                  path="/auth/forgot-password"
                  component={ForgotPassword}
                />
                <ContentRoute
                  path="/auth/reset-password/:token"
                  component={ResetPassword}
                />
                <Redirect from="/auth" exact={true} to="/auth/login" />
                <Redirect to="/auth/login" />
              </Switch>
            </div>
            {/*end::Content body*/}
            <Footer />
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}
